module.exports = __webpack_public_path__ + "static/media/baseline-keyboard_arrow_up-24px.b295f913.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/common/Icon/img/baseline-keyboard_arrow_up-24px.svg
// module id = 490
// module chunks = 0